var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useGenres } from "frontend/src/domain/genres";
import { usePlayer } from "frontend/src/domain/player-track-queue";
import { usePublishTracks, useRefreshTrackDurations, useUnpublishTracks, } from "frontend/src/domain/tracks";
import { useDeleteTracks } from "frontend/src/domain/tracks/actions";
import { pause, resume } from "frontend/src/features/control-audio";
import { playSearchResultAttempted } from "frontend/src/features/play-search-result";
import { useCallback, useEffect, useMemo, useState } from "react";
export var useCheckTracks = function (tracks) {
    var _a = useState({}), checkedTracks = _a[0], setCheckedTracks = _a[1];
    var checkedIds = Object.keys(checkedTracks).map(function (id) { return parseInt(id); });
    var checkedCount = checkedIds.length;
    var unCheckAll = function () { return setCheckedTracks({}); };
    var visibleTrackIds = useMemo(function () { return (tracks === null || tracks === void 0 ? void 0 : tracks.map(function (track) { return track.id; })) || []; }, [
        tracks,
    ]);
    var visibleCheckedCount = visibleTrackIds.filter(function (id) { return checkedTracks[id]; })
        .length;
    var isAllVisibleChecked = visibleTrackIds.length > 0 && visibleCheckedCount === visibleTrackIds.length;
    var isSomeVisibleChecked = visibleCheckedCount > 0 && visibleCheckedCount < visibleTrackIds.length;
    var toggleAllVisible = function () {
        if (isAllVisibleChecked) {
            setCheckedTracks(function (current) {
                return visibleTrackIds.reduce(function (acc, id) {
                    var _a = acc, _b = id, _ = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                    return rest;
                }, __assign({}, current));
            });
            return;
        }
        setCheckedTracks(function (current) {
            return visibleTrackIds.reduce(function (acc, id) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[id] = true, _a)));
            }, __assign({}, current));
        });
    };
    var genres = useGenres().genres;
    var genresMap = useMemo(function () {
        return genres === null || genres === void 0 ? void 0 : genres.reduce(function (acc, genre) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[genre.id] = genre.title, _a)));
        }, {});
    }, [genres]) || {};
    var toggleById = useCallback(function (id) {
        var _a;
        if (checkedTracks[id]) {
            setCheckedTracks(function (_a) {
                var _b = id, _ = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                return rest;
            });
        }
        else {
            setCheckedTracks(__assign((_a = {}, _a[id] = true, _a), checkedTracks));
        }
    }, [checkedTracks]);
    var player = usePlayer();
    var play = useCallback(function (index) {
        return playSearchResultAttempted({ tracks: tracks, startAtTrackIndex: index });
    }, [tracks]);
    var mapped = useMemo(function () {
        return tracks === null || tracks === void 0 ? void 0 : tracks.map(function (track) {
            var selected = Boolean(player && player.track.id === track.id);
            var loading = Boolean(selected && player.audio.loading);
            var playing = Boolean(selected && player.audio.playing);
            return __assign(__assign({}, track), { isChecked: track.id in checkedTracks, isSelectedForPlayer: selected, isLoading: loading, isPlaying: playing, genres: track.genres.map(function (genre) { return genresMap[genre.id]; }), genreIds: track.genres.map(function (genre) { return genre.id; }) });
        });
    }, [
        checkedTracks,
        tracks,
        genresMap,
        player === null || player === void 0 ? void 0 : player.track.id,
        player === null || player === void 0 ? void 0 : player.audio.loading,
        player === null || player === void 0 ? void 0 : player.audio.playing,
    ]);
    var publish = usePublishTracks();
    var unpublish = useUnpublishTracks();
    var refreshDurations = useRefreshTrackDurations();
    var removeMany = useDeleteTracks();
    var removeChecked = function () { return removeMany.do(checkedIds); };
    useEffect(function () {
        if (removeMany.isSuccess) {
            unCheckAll();
        }
    }, [removeMany.isSuccess]);
    return {
        toggleById: toggleById,
        tracks: mapped,
        checked: {
            count: checkedCount,
            none: checkedCount === 0,
            ids: checkedIds,
            visible: {
                all: isAllVisibleChecked,
                some: isSomeVisibleChecked,
                toggle: toggleAllVisible,
            },
        },
        unCheckAll: unCheckAll,
        removeChecked: removeChecked,
        publish: function () { return publish.do(checkedIds); },
        unpublish: function () { return unpublish.do(checkedIds); },
        refreshDurations: function () { return refreshDurations.do(checkedIds); },
        isRefreshingDurations: refreshDurations.isLoading,
        play: play,
        resume: resume,
        pause: pause,
    };
};
